import { request } from './api';
import config from '../config/index';
const ajaxMap = {};
const urls = {
  hotspotUrl: '/vrapi/tour/hotSpotList',
  carVrInfoBySeriesId: '/vrapi/car/carVrInfoBySeriesId',
  carExteriorAngle: 'ajax/GetCarExteriorAngle',
};
export default {
  /**
   *  wiki: http://wiki.corpautohome.com/pages/viewpage.action?pageId=88583617
   */
  getHotSpotList ({ dealerId, cityId, sceneId }) {
    const key = `getHotSpotList_${dealerId}_${cityId}_${sceneId}`;
    if (ajaxMap[key]) {
      ajaxMap[key].abort();
      delete ajaxMap[key];
    }
    const promise = request({
      type: 'get',
      dataType: 'json',
      url: config.dealerCloudVrapi + urls.hotspotUrl,
      data: {
        dealerId,
        cityId,
        sceneId,
      },
      complete: function () {
        ajaxMap[key] = 0;
      }
    });
    ajaxMap[key] = promise;
    return promise;
  },
  /**
   * 根据车系ID查询环视外观和全景内饰信息
   *  http://wiki.corpautohome.com/pages/viewpage.action?pageId=81001784
   * @param {*} param0
   */
  getCarVrInfoBySeriesId ({ seriesId }) {
    return request({
      type: 'get',
      dataType: 'json',
      url: config.dealerCloudVrapi + urls.carVrInfoBySeriesId,
      data: {
        seriesId,
        appId: 'dealer.vr'
      },
      transformResponse: function (data) {
        if (data) {
          return { returncode: 0, message: '', result: data.result };
        } else {
          return { returncode: 1, message: 'getCarVrInfoBySeriesId数据返回错误', result: data };
        }
      }
    });
  }
};
